import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { ProjectsService } from "../services/projects/projects.service";
import { UserServiceService } from "../services/user-service/user-service.service";
import swal from "sweetalert2";

@Component({
  selector: "add-project",
  templateUrl: "./add-project.component.html",
  styleUrls: ["./add-project.component.css"],
})
export class AddProjectComponent implements OnInit {
  sub: any;
  projectId: any;
  project: FormGroup;
  districts: any;
  phases: any = [{ serial: "", start_date: "", end_date: "" }];
  unit_excel_name: any;
  brochure_name: any;
  currentPhases: any = [];
  prePhases: any = [];
  userData: any = JSON.parse(window.localStorage.getItem("userProfile"));

  is_submitting: boolean = false;

  partners;
  partner_id: any;
  developers;
  partner_brokers: any[] = [];

  commissionInfo: any[] = [];
  fine_types = [
    {
      id: 1,
      name: "Day"
    },
    {
      id: 2,
      name: "Month"
    }
  ];
  sender_names;
  projectTypes: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public projectService: ProjectsService,
    private userService: UserServiceService,
    private router: Router,
    private slimLoadingBarService: SlimLoadingBarService,
    private errorHandlingservice: ErrorHandlerService
  ) {}

  ngOnInit() {
    this.getSenderNames();
    this.getProjectTypes();
    this.getPartners();
    this.getPartnerBrokers();
    this.getDistricts();
    this.getDevelopers();
    this.sub = this.route.params.subscribe((params) => {
      this.projectId = +params["id"];
      if (this.projectId == 0) this.createProject();
      else this.getProject();
    });
  }

  getSenderNames() {
    this.projectService.getSenderNames().subscribe((res: any) => {
      this.sender_names = res
    }, err => {
      this.errorHandlingservice.handleErorr(err)
    })
  }

  getProjectTypes() {
    this.projectService.getProjectTypes().subscribe((res: any) => {
      this.projectTypes = res;
    }, err => {
      this.errorHandlingservice.handleErorr(err)
    });
  }

  getPartners() {
    this.projectService.getPartners().subscribe((res: any) => {
      this.partners = res;
    });
  }

  getDevelopers() {
    this.projectService.getDevelopers().subscribe((res) => {
      this.developers = res;
    });
  }

  getPartnerBrokers() {
    this.userService
      .getBorkers({ is_select_form: true, is_partner: true })
      .subscribe(
        (res: any) => {
          this.partner_brokers = res || [];
        },
        (err) => {
          this.errorHandlingservice.handleErorr(err);
        }
      );
  }

  getProject() {
    this.createProject();
    this.slimLoadingBarService.start(() => {
    });
    this.projectService.getcurrentproject(this.projectId).subscribe(
      (data: any) => {
        this.project = this.formBuilder.group({
          name: [data.name, [Validators.required]],
          district_id: [data.district_id, Validators.required],
          // 'starting_price': ['', Validators.required],
          // 'installment': ['', Validators.required],
          details: [data.details, Validators.required],
          number_of_phases: [data.phases.length, Validators.required],
          unit_excel: [null],
          brochure_file: [null],
          project_image: [null],
          installment_image: [null],
          completion_rate: [data.completion_rate, Validators.required],
          down_payment: [data.down_payment, Validators.required],
          fine_type: [data.fine_type],
          sender_name: [data.sender_name],
          fine_percentage: [data.fine_percentage],
          service_room_price: [data.service_room_price, Validators.required],
          service_room_with_bathroom_price: [
            data.service_room_with_bathroom_price,
            Validators.required,
          ],
          garage_price: [data.garage_price, [Validators.min(0)]],
          delivery_date_interval: [data.delivery_date_interval],
          parking_slots: [data.parking_slots, Validators.required],
          available_storage: [data.available_storage, Validators.required],
          storage_price: [data.storage_price, Validators.required],
          extra_outdoor_meters: [
            data.extra_outdoor_meters,
            Validators.required,
          ],
          extra_outdoor_meter_price: [
            data.extra_outdoor_meter_price,
            Validators.required,
          ],
          sharing_bank_name: [
            data.sharing_bank_name,
          ],
          unit_type_ids: [data.unit_type_ids, Validators.required],
          eoi_types: [
            data.eoi_types ? data.eoi_types.map((e) => e.type) : [],
            Validators.required,
          ],
          developer_id: [data.developer_id],
          partner_id: [data.partner ? data.partner.id : null],
          partner_broker_id: [
            data.partner_broker_id ||
            (data.partner_broker ? data.partner_broker.id : null),
          ],
          interest_rate: [data.interest_rate],
          max_cash_discount: [data.max_cash_discount],
          max_discount_rate: [data.max_discount_rate],
          annual_discount_rate: [data.annual_discount_rate],
          commission_percentage: [data.commission_percentage],
          send_reminder: [data.send_reminder],
          commission_per_million: [
            data.commission_per_million,
            Validators.required,
          ],
          marketing_ratio: [
            data.marketing_ratio,
            Validators.required,
          ],
          master_plan: [[]],
          target_upto: [[]],
          commission: [[]],
          ambassador_commission: [[]],
          incentive: [[]],
        });
        let modifiedPhase: any = [];
        data.phases.forEach((e) => {
          modifiedPhase.push({
            serial: e.serial,
            start_date: e.start_date,
            end_date: e.end_date,
          });
        });
        data.commissions.map((commission_item) => {
          this.commissionInfo.push({
            target_upto: commission_item.target_upto,
            commission: commission_item.commission,
            ambassador_commission: commission_item.ambassador_commission || '',
            incentive: commission_item.incentive || ''
          });
        });
        this.prePhases = modifiedPhase;
        this.phases = modifiedPhase;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.complete();

        this.errorHandlingservice.handleErorr(err);
      }
    );
  }

  createProject() {
    this.project = this.formBuilder.group({
      name: ["", [Validators.required]],
      district_id: [null, Validators.required],
      // 'starting_price': ['', Validators.required],
      // 'installment': ['', Validators.required],
      details: ["", Validators.required],
      number_of_phases: ["", Validators.required],
      unit_excel: [null],
      brochure_file: [null],
      project_image: [null],
      installment_image: [null],
      completion_rate: [0, Validators.required],
      down_payment: [null, Validators.required],
      fine_type: [null],
      sender_name: [null],
      fine_percentage: [null],
      service_room_price: [null, Validators.required],
      service_room_with_bathroom_price: [null, Validators.required],
      garage_price: [0],
      delivery_date_interval: [0],
      parking_slots: [0, Validators.required],
      available_storage: [0, Validators.required],
      storage_price: [0, Validators.required],
      extra_outdoor_meters: [0, Validators.required],
      extra_outdoor_meter_price: [0, Validators.required],
      sharing_bank_name: [''],
      unit_type_ids: [null, Validators.required],
      eoi_types: [[]],
      partner_id: [null],
      developer_id: [null],
      partner_broker_id: [null],
      interest_rate: [null],
      max_cash_discount: [null],
      max_discount_rate: [null],
      annual_discount_rate: [null],
      commission_percentage: [null],
      send_reminder: [""],
      commission_per_million: ["", Validators.required],
      marketing_ratio: [""],
      master_plan: [[]],
      commission: [[]],
      target_upto: [[]],
      ambassador_commission: [[]],
      incentive: [[]],
    });
  }

  getDistricts() {
    this.projectService.getDistricts().subscribe(
      (data) => {
        this.districts = data;
      },
      (err) => this.errorHandlingservice.handleErorr(err)
    );
  }

  addCommissionInfo() {
    this.commissionInfo.push({
      target_upto: "",
      commission: "",
      ambassador_commission: "",
      incentive: ""
    });
  }

  removeCommissionInfo(index) {
    this.commissionInfo.splice(index, 1);
  }

  trackCommissionInfo(index: number, commissionInfoItemType: string, value) {
    this.commissionInfo[index][commissionInfoItemType] = value;
  }

  addCommissionInfoTarget() {
    let target_upto_values = [];
    let commission_values = [];
    let ambassador_commission_values = [];
    let incentive_values = [];
    this.commissionInfo.map((e) => {
      if (e.target_upto) {
        target_upto_values.push(e.target_upto);
      }
      if (e.commission) {
        commission_values.push(e.commission);
      }
      if (e.ambassador_commission) {
        ambassador_commission_values.push(e.ambassador_commission);
      }
      if (e.incentive) {
        incentive_values.push(e.incentive);
      }
    });
    target_upto_values.length > 0 &&
      this.project.get("target_upto").setValue(target_upto_values);
    commission_values.length > 0 &&
      this.project.get("commission").setValue(commission_values);
    ambassador_commission_values.length > 0 &&
      this.project.get("ambassador_commission").setValue(ambassador_commission_values);
    incentive_values.length > 0 &&
      this.project.get("incentive").setValue(incentive_values);
  }

  onExcelChange(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      this.unit_excel_name = file.name;
      reader.onload = () => {
        this.project.get("unit_excel").setValue({
          unit_excel_name: file.name,
          unit_excel_filetype: file.type,
          unit_excel_value: (reader.result as any).split(",")[1],
        });
      };
    }
  }

  onProjectImage(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      this.unit_excel_name = file.name;
      reader.onload = () => {
        this.project.get("project_image").setValue({
          project_image_name: file.name,
          project_image_type: file.type,
          project_image_value: (reader.result as any).split(",")[1],
        });
      };
    }
  }

  onBrochureChange(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      if (file.size / 1024 / 1024 > 20) {
        swal("error", "file must be smaller than 20MB.", "error");
        return;
      }
      reader.readAsDataURL(file);
      this.brochure_name = file.name;
      reader.onload = () => {
        this.project.get("brochure_file").setValue({
          brochure_name: file.name,
          brochure_value: (reader.result as any).split(",")[1],
        });
      };
    }
  }

  onInstallmentImage(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      this.unit_excel_name = file.name;
      reader.onload = () => {
        this.project.get("installment_image").setValue({
          installment_logo_name: file.name,
          installment_logo_value: (reader.result as any).split(",")[1],
        });
      };
    }
  }

  onStaticMasterPlanImage(event) {
    if (event.target.files && event.target.files.length > 0) {
      // this.handleStaticMasterPlanImage(event.target.files).subscribe((res) => {
      // })
      let images = this.handleStaticMasterPlanImage(event.target.files);
      this.project.get("master_plan").setValue(images);
    }
  }

  handleStaticMasterPlanImage(imageArray) {
    let images = Object.values(imageArray);
    let imageBase46 = [];
    for (let i = 0; i < images.length; i++) {
      let img: any = images[i];
      let reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = () => {
        let imgObject = {
          master_image_name: img.name,
          master_image_type: img.type,
          master_image_value: (reader.result as any).split(",")[1],
        };
        imageBase46.push(imgObject);
      };
    }
    return imageBase46;
  }

  save() {
    this.addCommissionInfoTarget();
    let formModel = this.project.value;
    formModel.phases = this.phases;
    formModel.down_payment = formModel.down_payment.toString();
    if(formModel.fine_percentage > 100 || formModel.fine_percentage < 0){
      swal("Fine Percentage should be between 0 to 100","","error");
      this.is_submitting = false;
      return;
    }
    if(formModel.marketing_ratio > 100 || formModel.marketing_ratio < 0){
      swal("Marketing Percentage should be between 0 to 100","","error");
      this.is_submitting = false;
      return;
    }
    if (this.projectId == 0) {
      this.slimLoadingBarService.start(() => {
      });
      this.is_submitting = true;
      this.projectService.addProject(formModel).subscribe(
        (data) => {
          this.router.navigate(["/pages/projects"]);
          this.slimLoadingBarService.complete();
          this.is_submitting = false;
        },
        (err) => {
          this.is_submitting = false;
          this.errorHandlingservice.handleErorr(err);
        }
      );
    } else {
      this.slimLoadingBarService.start();
      this.is_submitting = true;
      this.projectService.UpdateProject(this.projectId, formModel).subscribe(
        (data) => {
          this.slimLoadingBarService.complete();
          this.router.navigate(["/pages/projects"]);
          this.is_submitting = false;
        },
        (err) => {
          this.errorHandlingservice.handleErorr(err);
          this.is_submitting = false;
        }
      );
    }
  }

  onSelectAllItems(field: string, items: any, key = "id") {
    this[field] = items.map((f) => "" + f[key]);
    this.project.get(field).setValue(this[field]);
  }

  onClearAllItems(field: string) {
    this[field] = [];
    this.project.get(field).setValue(this[field]);
  }

  selectPhasesNumber(event) {
    let number_of_phases: any = this.project.get("number_of_phases").value;
    if (number_of_phases >= 1 && number_of_phases < 21) {
      this.phases = [];
      for (var i = 0; i < number_of_phases; i++) {
        this.phases.push({ serial: "", start: "", end: "" });
      }
      if (this.phases.length != 0) {
        this.prePhases.forEach((e, i) => {
          if (this.phases[i]) {
            this.phases[i].serial = e.serial;
            this.phases[i].start_date = e.start_date;
            this.phases[i].end_date = e.end_date;
          }
        });
      }
    } else {
      this.project.patchValue({
        number_of_phases: "",
      });
      this.phases = [{ serial: "", start_date: "", end_date: "" }];
    }
  }
  gotodashboard() {
    this.router.navigate(["/pages/projects"]);
  }
}



// WEBPACK FOOTER //
// ./src/app/add-project/add-project.component.ts